<template>
  <div style="margin: 0 64px 8px;">
    <el-form ref="formRef" :model="bonusForm" label-width="auto" label-position="right">
      <el-form-item label="洗澡项目：">
        <el-input v-model="bonusForm.washing" placeholder="请输入提成金额" ><template #suffix>元</template></el-input>
      </el-form-item>
      <el-form-item label="复购奖励：">
        <el-input v-model="bonusForm.washingRepurchase" placeholder="请输入复购奖励" ><template #suffix>元</template></el-input>
      </el-form-item>
      <el-form-item label="增值服务：">
        <el-input v-model="bonusForm.increment" placeholder="请输入提成比例" ><template #suffix>%</template></el-input>
      </el-form-item>
      <el-form-item label="物品销售：">
        <el-input v-model="bonusForm.goodSales" placeholder="请输入提成比例" ><template #suffix>%</template></el-input>
      </el-form-item>
      <el-form-item label="活体销售：">
        <el-input v-model="bonusForm.liveSales" placeholder="请输入提成比例" ><template #suffix>%</template></el-input>
      </el-form-item>
      <el-form-item label="其他：">
        <el-input v-model="bonusForm.other" placeholder="请输入提成比例" ><template #suffix>%</template></el-input>
      </el-form-item>
      <el-form-item label="客户充值：">
        <el-input v-model="bonusForm.userPay" placeholder="请输入提成比例" ><template #suffix>%</template></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { updateShopBonus } from "@/api/url";
import { positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      bonusForm: this.value.bonusForm,
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      // console.log(this.idx)
      if(!positiveIntReg.test(this.bonusForm.washing)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '洗澡项目输入错误',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.bonusForm.washingRepurchase)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入复购奖励',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.bonusForm.increment)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '增值服务输入错误',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.bonusForm.goodSales)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '物品销售输入错误',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.bonusForm.liveSales)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '活体销售输入错误',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.bonusForm.other)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '其他输入错误',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.bonusForm.userPay)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '客户充值输入错误',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['shopId'] = this.bonusForm.shopId;
      param['validDate'] = this.bonusForm.validDate;
      param['washing'] = this.bonusForm.washing;
      param['washingRepurchase'] = this.bonusForm.washingRepurchase;
      param['increment'] = this.bonusForm.increment;
      param['goodSales'] = this.bonusForm.goodSales;
      param['liveSales'] = this.bonusForm.liveSales;
      param['other'] = this.bonusForm.other;
      param['userPay'] = this.bonusForm.userPay;
      postFormData(updateShopBonus, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
